export { default } from './new-tab-processing';
